let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8mTi8")).then(() => parcelRequire('aKp87'));